import request from '@/utils/request'

export const createStockTakeSession = (data) => {
  return request({
    url: '/api/inventory-stock-take/sessions',
    method: 'post',
    data,
    timeout: 120000
  })
}

/**
 * 整排/多库位批量盖章：每个库位各写一条 stamp_only 会话。
 * body: { storage_location_ids: number[], warehouse_location_id?, notes?, skip_already_stamped? }
 */
export const batchStampStockTakeSessions = (data) => {
  return request({
    url: '/api/inventory-stock-take/sessions/batch-stamp',
    method: 'post',
    data,
    timeout: 180000
  })
}

export const getStockTakeSessions = (params) => {
  return request({
    url: '/api/inventory-stock-take/sessions',
    method: 'get',
    params
  })
}

export const getStockTakeSession = (sessionId) => {
  return request({
    url: `/api/inventory-stock-take/sessions/${sessionId}`,
    method: 'get'
  })
}

export const voidStockTakeSession = (sessionId) => {
  return request({
    url: `/api/inventory-stock-take/sessions/${sessionId}/void`,
    method: 'post',
    timeout: 60000
  })
}

/**
 * 管理员：批量作废印记时间早于 before 的盖章（不清除材料「已盘」勾选）。
 * body: { before, warehouse_location_id?, round_id? }
 */
export const voidStockTakeSessionsBefore = (data) => {
  return request({
    url: '/api/inventory-stock-take/sessions/void-before',
    method: 'post',
    data,
    timeout: 180000
  })
}

/**
 * 重盘：作废指定库位当前 open 轮印记，并清除本轮「已盘」勾选。
 * body: { storage_location_ids: number[], warehouse_location_id? }
 */
export const reCountStockTakeScope = (data) => {
  return request({
    url: '/api/inventory-stock-take/re-count',
    method: 'post',
    data,
    timeout: 180000
  })
}

/** 单行「已盘 / 实盘」写入（绑定当前 open 轮次），body: { inventory_id, is_checked?, counted_quantity?, warehouse_location_id? } */
export const patchMobileStockTakeLineMark = (data) => {
  return request({
    url: '/api/inventory-stock-take/mobile-line-mark',
    method: 'patch',
    data,
    timeout: 60000
  })
}

export const getStockTakeRounds = (params) => {
  return request({
    url: '/api/inventory-stock-take/rounds',
    method: 'get',
    params
  })
}

export const createStockTakeRound = (data) => {
  return request({
    url: '/api/inventory-stock-take/rounds',
    method: 'post',
    data,
    timeout: 60000
  })
}

export const getStockTakeRound = (roundId) => {
  return request({
    url: `/api/inventory-stock-take/rounds/${roundId}`,
    method: 'get'
  })
}

export const closeStockTakeRound = (roundId, data = {}) => {
  return request({
    url: `/api/inventory-stock-take/rounds/${roundId}/close`,
    method: 'post',
    data,
    timeout: 60000
  })
}
